export class Lot {
    NumeroLot: string
    DocumentCode: string

    static mapFromJSON(json: any): Lot {
        const t = new Lot();

        t.NumeroLot = json.numeroLot;
        t.DocumentCode = json.documentCode;

        return t;
    }
}